// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getDatabase } from "firebase/database";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDxJhvcDEpmYgC7Fp_9z5zfabbAGH8_QgY",
  authDomain: "iam-card-game.firebaseapp.com",
  databaseURL: "https://iam-card-game.firebaseio.com",
  projectId: "iam-card-game",
  storageBucket: "iam-card-game.appspot.com",
  messagingSenderId: "834914857608",
  appId: "1:834914857608:web:a650175c550609252be53d",
  measurementId: "G-5M2LKSXZ82",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const db = getDatabase();
const analytics = getAnalytics(app);
